/**
 * API client per le notifiche push.
 *
 * Endpoints:
 * - POST /api/v1/push/subscribe - Registra sottoscrizione
 * - GET /api/v1/push/subscriptions - Lista sottoscrizioni
 * - POST /api/v1/push/send - Invia push (admin)
 */

import axios from 'axios';

export interface PushSubscribeRequest {
  subscription: PushSubscriptionJSON;
  user_agent: string;
}

export interface PushSubscriptionOut {
  id: string;
  user_id: string;
  username: string;
  endpoint: string;
  created_at: string;
  user_agent: string;
}

export interface PushSendRequest {
  user_id?: string;
  title: string;
  body: string;
  url?: string;
}

export interface PushSendResponse {
  sent: number;
  failed: number;
}

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const pushApi = {
  /**
   * Registra una nuova sottoscrizione push.
   */
  subscribe: async (data: PushSubscribeRequest): Promise<{ message: string }> => {
    const response = await api.post('/push/subscribe', data);
    return response.data;
  },

  /**
   * Lista tutte le sottoscrizioni (admin).
   */
  listSubscriptions: async (): Promise<PushSubscriptionOut[]> => {
    const response = await api.get<PushSubscriptionOut[]>('/push/subscriptions');
    return response.data;
  },

  /**
   * Invia una notifica push (admin).
   */
  send: async (data: PushSendRequest): Promise<PushSendResponse> => {
    const response = await api.post<PushSendResponse>('/push/send', data);
    return response.data;
  },
};
